


































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































	import { Component, Vue } from "vue-property-decorator";
	import {
		SelectedCountry,
		RedCapital,
		TitleTemplateDashboard,
	} from "@/configuration";
	import { mapState } from "vuex";
	import API from "@/api";
	import TableResponsive from "@/components/table/TableResponsive.vue";
	// @ts-ignore
	import { Tabs, TabItem } from 'vue-material-tabs';
	import ShowLoading from "@/components/panel/ShowLoading.vue";
	import moment from "moment";
	// @ts-ignore
	import jsPDF from "jspdf";
	import { numeroALetras } from "@/utils";

	@Component({
		metaInfo: {
			title: "Mis documentos",
			titleTemplate: TitleTemplateDashboard,
			htmlAttrs: {
				// @ts-ignore
				lang: RedCapital[SelectedCountry].Lang,
			},
		},
		computed: {
			...mapState(["user","setOpenMenuPanel"]),
			setOpenMenuPanel(){
				return this.$store.state.openMenuPanel;
			},
		},
  		data() {
			return {
				canShow: false,
				searchContratos: "",
				searchMandatos: "",
				searchPagaresRespaldo: "",
				SelectedCountry,
				RedCapital,
				contratosApi: null,
				mandatosApi: null,
				pagaresRespaldoApi: null,
				selectedTerm: 1,
				tablaContratos: {
					headers: [
						{
							text: "Nombre contrato",
							align: "center",
							value: "contrato.nombre",
						},
						{
							text: "Fecha",
							align: "center",
							value: "fecha",
						},
						{
							text: "Estado",
							align: "center",
							value: "estado.descripcion",
						},
						{
							text: "Acciones",
							align: "center",
							sortable: false,
						},
					],
					msjEmpty: 'No existen registros en tu cuenta',
					rowsPerPage: {
						txt: 'Registro por página',
						itm: [10, 25, 50, { text: 'Todos', value: -1 }]
					},
				},
				tablaMandatos: {
					headers: [
						{
							text: "Nombre contrato",
							align: "center",
							value: "contrato.nombre",
						},
						{
							text: "Proyecto Id",
							align: "center",
							value: "proyecto.id",
						},
						{
							text: "Nombre proyecto",
							align: "center",
							value: "proyecto.nombre",
						},
						{
							text: "Fecha",
							align: "center",
							value: "fecha",
						},
						{
							text: "Estado",
							align: "center",
							value: "estado.descripcion",
						},
						{
							text: "Acciones",
							align: "center",
							sortable: false,
						},
					],
					msjEmpty: 'No existen registros en tu cuenta',
					rowsPerPage: {
						txt: 'Registro por página',
						itm: [10, 25, 50, { text: 'Todos', value: -1 }]
					},
				},
				tablaPagaresRespaldos: {
					headers: [
						{
							text: "Nombre contrato",
							align: "center",
							value: "contrato.nombre",
						},
						{
							text: "Fecha",
							align: "center",
							value: "fecha",
						},
						{
							text: "Acciones",
							align: "center",
							sortable: false,
						},
					],
					msjEmpty: 'No existen registros en tu cuenta',
					rowsPerPage: {
						txt: 'Registro por página',
						itm: [10, 25, 50, { text: 'Todos', value: -1 }]
					},
				},
				term: null,
				country: null,
				numeroALetras,
			};
  		},
		async beforeMount() {
			// Seteo Country
			if (this.$store.state.user.pais_id == 1) {
				this.$data.country = "Chilena";
			} else if (this.$store.state.user.pais_id == 2) {
				this.$data.country = "Argentina";
			} else if (this.$store.state.user.pais_id == 3) {
				this.$data.country = "Peruana";
			} else if (this.$store.state.user.pais_id == 4) {
				this.$data.country = "Estadounidense";
			}
			// API Contratos
			this.$data.contratosApi = await API.documents.contracts();
		
			// API Mandatos
			this.$data.mandatosApi = await API.documents.terms();
			this.$data.mandatosApi = this.$data.mandatosApi.filter(
				(term: any) => term.inversion != null
			);
			// API Pagares y Respaldo
			this.$data.pagaresRespaldoApi = await API.documents.ious();
			/* Format Data */
			/* Estilos para tablas mobiles */
			let propsObjTableAll = {
				style: `text-align: center;
						font-size: 0.7rem;
						font-weight: 500;
						color: #8b8b8b`
			}
			let propsObjTableButtons = {
				style: `display: flex;
						justify-content: center;`
			}
			/* Format data Tabla Contratos */
			Array.from(this.$data.contratosApi, contrato => {
				// @ts-ignore
				if(contrato.fecha){
					// @ts-ignore
					contrato.fecha = moment(contrato.fecha).format("DD-MM-YYYY");
				}else {
					// @ts-ignore
					contrato.fecha = '-';
				}
				
				let objTableContratos = {
					nombreContrato:{
						// @ts-ignore
						value: contrato.contrato.nombre,
						label: 'Nombre contrato',
						props: propsObjTableAll
					},
					fecha:{
						// @ts-ignore
						value: contrato.fecha,
						label: 'Fecha',
						props: propsObjTableAll
					},
					estado:{
						// @ts-ignore
						value: this.capitalize(contrato.estado.descripcion),
						label: 'Estado',
						props: propsObjTableAll
					},
					acciones:{
						value: 'Pendiente',
						label: 'Acciones',
						props: propsObjTableButtons,
						button: {
							funcion: 'solicitanteMisDocumentos_generatePDFChild',
							icoFont: 'download',
							notOutline: true,
							// @ts-ignore
							data: contrato.contrato_id
						},
					}
				}
				// @ts-ignore
				contrato.datosEnTabla = objTableContratos;
			})
			/* Format data Tabla Mandatos */
			Array.from(this.$data.mandatosApi, mandato => {
				// @ts-ignore
				mandato.fecha = moment(mandato.fecha).format("DD-MM-YYYY");
				let objTableMandatos = {
					nombreContrato:{
						// @ts-ignore
						value: mandato.contrato.nombre,
						label: 'Nombre contrato',
						props: propsObjTableAll
					},
					proyectoId:{
						// @ts-ignore
						value: mandato.proyecto.id,
						label: 'Proyecto id',
						props: propsObjTableAll
					},
					nombreProyecto:{
						// @ts-ignore
						value: mandato.proyecto.nombre,
						label: 'Nombre proyecto',
						props: propsObjTableAll
					},
					fecha:{
						// @ts-ignore
						value: mandato.fecha,
						label: 'Fecha',
						props: propsObjTableAll
					},
					estado:{
						// @ts-ignore
						value: this.capitalize(mandato.estado.descripcion),
						label: 'Estado',
						props: propsObjTableAll
					},
					acciones:{
						value: 'Pendiente',
						label: 'Acciones',
						props: propsObjTableButtons,
						button: {
							funcion: 'solicitanteMisDocumentos_genPDFChild',
							icoFont: 'download',
							notOutline: true,
							// @ts-ignore
							data: mandato.id
						},
					}
				}
				// @ts-ignore
				mandato.datosEnTabla = objTableMandatos;
			});
			/* Format data Tabla Pagares y Respaldos */
			Array.from(this.$data.pagaresRespaldoApi, pagareRespaldo => {
				// @ts-ignore
				pagareRespaldo.fecha = moment(pagareRespaldo.fecha).format("DD-MM-YYYY");
				let objTablePagaresRespaldos = {
					nombreContrato:{
						// @ts-ignore
						value: pagareRespaldo.contrato.nombre,
						label: 'Nombre contrato',
						props: propsObjTableAll
					},
					fecha:{
						// @ts-ignore
						value: pagareRespaldo.fecha,
						label: 'Fecha',
						props: propsObjTableAll
					},
					acciones:{
						value: 'Pendiente',
						label: 'Acciones',
						props: propsObjTableButtons,
						href: {
							icoFont: 'folder',
							notOutline: true,
							// @ts-ignore
							to: pagareRespaldo.href
						},
					}
				}
				// @ts-ignore
				pagareRespaldo.datosEnTabla = objTablePagaresRespaldos;
			});
			/* Termina */
			this.$data.canShow = true;
		},
		methods: {
			capitalize(texto: string){
				let lower = texto.toLowerCase()
				return texto.charAt(0).toUpperCase()+lower.slice(1)
			},
			genPDF(id: number) {
				this.$data.selectedTerm = id;
				setTimeout(() => {
					let doc = new jsPDF();
					let source = document.getElementById("pdfMandatos");
					doc.fromHTML(source, 20, 20, {
						width: 170,
					});
					doc.save(
						`mandato-${this.$data.selectedTerm}-${this.$store.state.user.rut}.pdf`
					);
				}, 500);
			},
			/* Funciones PDF contratos */
			generatePDF(id: number) {
				switch (id) {
					case 1:
						// @ts-ignore
						this.genDefinitionsPDF();
						break;
					case 2:
						// @ts-ignore
						this.genContratoPDF();
						break;
					default:
						return 0
						break;
				}
			},
			genContratoPDF() {
				setTimeout(() => {
					let doc = new jsPDF();
					let source = document.getElementById("pdfTerminosCondiciones");
					doc.fromHTML(source, 10, 10, {
						width: 170,
					});

					doc.save(
						`contrato-terminos-condiciones-${this.$store.state.user.rut}.pdf`
					);
				}, 500);
			},
			genDefinitionsPDF() {
				setTimeout(() =>{
					var fileURL = "/pdf/DEFINICIONES_Y_ANTECEDENTES_PREVIOS_AL_USO_DE_REDCAPITAL.pdf";
					var fileName = "DEFINICIONES_Y_ANTECEDENTES_PREVIOS_AL_USO_DE_REDCAPITAL";
					// for non-IE
					if (!window.ActiveXObject) {
						var save = document.createElement('a');
						save.href = fileURL;
						save.target = '_blank';
						save.download = fileName || 'unknown';

						var evt = new MouseEvent('click', {
							'view': window,
							'bubbles': true,
							'cancelable': false
						});
						save.dispatchEvent(evt);

						(window.URL || window.webkitURL).revokeObjectURL(save.href);
					}

					// for IE < 11
					// @ts-ignore
					else if ( !! window.ActiveXObject && document.execCommand)     {
						var _window = window.open(fileURL, '_blank');
						//@ts-ignore
						_window.document.close();
							//@ts-ignore
						_window.document.execCommand('SaveAs', true, fileName || fileURL)
							//@ts-ignore
						_window.close();
					}
				},500)
			},
		},
		watch: {
			selectedTerm(val) {
				this.$data.term = this.$data.mandatosApi.find((term: any) => term.id == val);
			},
		},
		components: {
			TableResponsive,
			Tabs,
			TabItem,
			ShowLoading
		}
	})
	export default class Contracts extends Vue {}
